import React from "react";
import { useGoogleLogin } from '@react-oauth/google';

import { authenticationService } from "../../../../jwt/_services";
import { useLocation, useHistory } from "react-router-dom";

import GoogleLogoSvg from "../../../../assets/images/google-logo.svg"


const GoogleLogin = ({setAuthError, setAuthErrorMsg}) => {

    const location = useLocation();
    const history = useHistory();

    const { from } = location.state || { from: { pathname: "/" } }

    const googleLogin = useGoogleLogin({
        flow: "auth-code",
        onSuccess: async (codeResponse) => {
            let authCode = codeResponse.code;
            authenticationService.socialAuth("google-oauth2", authCode, "postmessage", "login").then(
                user => {
                    history.push(from);
                },
                error => {
                    let errorMsg = "Error in login with Google";
                    if(error) {
                        errorMsg = error;
                    }
                    console.log(errorMsg);
                    setAuthErrorMsg(errorMsg);
                    setAuthError(true);
                }
            );
        },
        onError: (errorResponse) => {
            console.log("Error in login with Google");
            console.log(errorResponse);
            setAuthErrorMsg("Error in login with Google");
            setAuthError(true);
        },
    });


  return (
    <>
        <div onClick={() => { 
            setAuthError(false);
            setAuthErrorMsg("");
            googleLogin();
        }}>
            <span className="google-btn">
                <img width="20px" height="100%" style={{marginBottom: '3px', marginRight: '16px'}} alt="Google login" src={GoogleLogoSvg} />
                SIGN IN WITH GOOGLE
            </span>
        </div>
    </>
  );
};


export default GoogleLogin;
